import script from "./BaseLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseLayout.vue?vue&type=script&lang=ts&setup=true"

import "./BaseLayout.vue?vue&type=style&index=0&id=d08d893e&lang=css"
import "./BaseLayout.vue?vue&type=style&index=1&id=d08d893e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_typescript@4.9.5__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d08d893e"]])

export default __exports__